import React from 'react'
import { motion } from 'framer-motion'
import hcLogo from '../images/haystack conference logo W 1 (1).png'
import wfm from '../images/WFM LOGO WHITE 1 (1).png'

const Footer = () => {
    return (
        <motion.div
            className="flex justify-center items-center flex-col xl:px-32 px-24 py-16 bg-black before:font-inter"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
        >
            <motion.div
                className="border-b border-white py-12 flex lg:flex-row gap-y-10 flex-col items-center justify-between gap-x-48 w-full text-white font-regular text-lg"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.3, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.5 }}
                    viewport={{ once: true }}
                >
                    <img src={hcLogo} alt="Haystack Conference Logo" className="w-60" />
                </motion.div>

                <motion.div
                    className="flex md:flex-row flex-col items-center gap-y-10 justify-between"
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.5 }}
                    viewport={{ once: true }}
                >
                    <div className="flex md:flex-row flex-col items-center gap-x-2">
                        <span>Contact us</span>
                        <span className="underline underline-offset-4 text-base">+234 806 142 7061</span>
                    </div>
                </motion.div>
            </motion.div>

            <motion.div
                className="flex flex-col gap-y-5 my-8 justify-center items-center"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.6, ease: "easeOut" }}
                viewport={{ once: true }}
            >
                <img src={wfm} alt="WFM Logo" className="w-40" />
                <p className="text-blackY text-sm">Copyright © 2026 Lightstream Media</p>
            </motion.div>
        </motion.div>
    )
}

export default Footer
